export default __webpack_public_path__ + "static/media/visitor-centre-highlight.8e764213.svg";